document.addEventListener('DOMContentLoaded', function() {
  // Initialize GSAP with ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Get all card elements with the card-effect-item class
  const cards = document.querySelectorAll('.card-effect-item');
  
  if (cards.length > 0) {
    // Set initial scale for all cards except the first one
    gsap.set(cards, { 
      scale: 1,
      y: 20,
      transformOrigin: "center top"
    });
    
    gsap.set(cards[0], {
      scale: 1,
      y: 0
    });

    // Create scroll animations for each card
    cards.forEach((card, index) => {
      // Skip the first card as it's already at full scale
      if (index === 0) return;
      
      // Create a scroll trigger for each card
      ScrollTrigger.create({
        trigger: card,
        start: "top center", // Start when the top of the card reaches the center of the viewport
        end: "bottom center", // End when the bottom of the card passes the center of the viewport
        scrub: true,
        // markers: true, // For debugging
        onEnter: () => {
          // Animate the current card to full scale
          gsap.to(card, {
            scale: 1,
            y: 0,
            duration: 0.3,
            ease: "power2.out"
          });
          
          // Scale down previous cards with staggered offset
          for (let i = 0; i < index; i++) {
            gsap.to(cards[i], {
              scale: 0.9,
              y: -20 - (i * 5), // Add staggered offset
              duration: 0.3,
              ease: "power2.out"
            });
          }
        },
        onLeaveBack: () => {
          // Restore original scale for the current card
          gsap.to(card, {
            scale: 1,
            y: 20,
            duration: 0.3,
            ease: "power2.out"
          });
          
          // Restore scale for previous cards
          if (index > 0) {
            // Restore previous cards with staggered positioning
            for (let i = 0; i < index; i++) {
              let yOffset = 0;
              if (i < index - 1) {
                yOffset = -10 - (i * 3); // Smaller staggered offset for cards still in back
              }
              
              gsap.to(cards[i], {
                scale: i === index - 1 ? 1 : 0.95,
                y: i === index - 1 ? 0 : yOffset,
                duration: 0.3,
                ease: "power2.out"
              });
            }
          }
        }
      });
    });
  }
});
